import React from 'react';
import './App.css';
import Home from './pages/home';
import Empresa from './pages/empresa';
import Receitas from './pages/receitas';
import ExibReceitas from './pages/exibiçãoReceitas'
import Header from './components/Header';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";


function App() {
  return (
    <Router>
        <Header/>
          <Route path='/' component={Home} exact/>
          <Route path='/empresa' component={Empresa}/>
          <Route path='/receitas' component={ExibReceitas}/>
          <Route path='/edicaodereceitas' component={Receitas}/>
    </Router>
  );
}

export default App;
